import React, { useState } from 'react';
import { Typography, Input } from 'antd';

const { Text } = Typography;
const { Search } = Input;

const TranscriptText = ({ seekOnTranscriptClick, textArray, videoTimestamp }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleOnClick = (event) => {
        seekOnTranscriptClick(event.target, event.target.getAttribute('data-start-time'))
    }

    const highlightMatch = (text, term) => {
        if (!term) return text;

        const regex = new RegExp(`(${term})`, 'gi');
        const parts = text.split(regex);

        return parts.map((part, i) =>
            regex.test(part) ? (
                <mark key={i}>{part}</mark>
            ) : (
                part
            )
        );
    };

    return (
        <><div className='sticky-section transaction-search-section'>
                <Search
                    placeholder="Search transcript"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    allowClear
                />
            </div>
            <div>
            
                {textArray.map((textSegment, index) => {
                    var highlighted = textSegment.startTime <= videoTimestamp && textSegment.endTime > videoTimestamp ? "highlighted-transcript-segment" : ""
                    return <Text
                        data-start-time={textSegment.startTime}
                        data-end-time={textSegment.endTime}
                        data-paragraph-flag={textSegment.startOfParagraph}
                        key={index} id={highlighted} className="transcript-segment" onClick={handleOnClick}>{textSegment.startOfParagraph && index !== 0 ? <><br /><br /></> : null}{highlightMatch(textSegment.text, searchTerm)} </Text>
                })}

            </div>
        </>
    )


}

export default TranscriptText;